const reactTInit = () => {
  if (typeof Drupal !== 'undefined') {
    /*global Drupal:true*/
    Drupal.t('Search across sites');
    Drupal.t('Type');
    Drupal.t('Topic');
    Drupal.t('Topics');
    Drupal.t('Tags');
    Drupal.t('Keywords');
    Drupal.t('Categories');
    Drupal.t('Category');
    Drupal.t('Document type');
    Drupal.t('Document types');
    Drupal.t('Publication category');
    Drupal.t('Publication categories');
    Drupal.t('Supporter category');
    Drupal.t('Supporter categories');
    Drupal.t('Event category');
    Drupal.t('Event categories');
    Drupal.t('News category');
    Drupal.t('News categories');
    Drupal.t('Event type');
    Drupal.t('Event types');
    Drupal.t('Date');
    Drupal.t('Audience');
    Drupal.t('Public event');
    Drupal.t('Private event');
    Drupal.t('Invite-only event');
    Drupal.t('Country');
    Drupal.t('Countries');
    Drupal.t('Region');
    Drupal.t('Regions');
    Drupal.t('Date');
    Drupal.t('Showing @count results for');
    Drupal.t('Sorry, your search yielded no results.');
    Drupal.t('No filters for the results of your search, try to use another Keyword/Date.');
    Drupal.t('Sort by');
    Drupal.t('Relevance');
    Drupal.t('Reset all filters');
    Drupal.t('Filters');
    Drupal.t('From Date');
    Drupal.t('To Date');
    Drupal.t('Last 3 months');
    Drupal.t('Last 1 year');
    Drupal.t('Last 3 years');
    Drupal.t('There are no results to filter.');
    Drupal.t('First');
    Drupal.t('Previous');
    Drupal.t('Next');
    Drupal.t('Last');
    Drupal.t('Site');
    Drupal.t('Find publications');
    Drupal.t('Find events');
    Drupal.t('Find news');
    Drupal.t('Find prominent supporters');
    Drupal.t('Clear');
    Drupal.t('Apply');
    Drupal.t('No results found.');
    Drupal.t('Show all in');
    Drupal.t('Show all');
    Drupal.t('Clear selection');
    Drupal.t('Search');
    Drupal.t('Search in');
    Drupal.t('Document topic');
    Drupal.t('Document country');
    Drupal.t('Upcoming');
    Drupal.t('Keyword');
    Drupal.t('Attachments');
    Drupal.t('Waiting for results');
    Drupal.t('Showing @count result for')
    Drupal.t('Tag');
    Drupal.t('Global site');
    Drupal.t('Africa site');
    Drupal.t('Asia site');
    Drupal.t('Australia site');
    Drupal.t('Ireland site');
    Drupal.t('India site');
    Drupal.t('Malaysia site');
    Drupal.t('US site');
    Drupal.t('Spain site');
    Drupal.t('Mexico site');
    Drupal.t('Europe site');
    Drupal.t('France site');
    Drupal.t('Korean site');
    Drupal.t('UK site');
    Drupal.t('The search feature is currently unavailable due to technical maintenance. Please try again later. Thank you for your understanding.');
    Drupal.t('Loading fallback results...');
  }
};

export default reactTInit;
